import { FlexRemoteResurrectArgs, FlexRemoteResurrectQuery } from '../../autogenerated/ZoomBridge';
import ErrorHandler from '../../error/ErrorHandler';
import t from '../../i18n/I18n';
import { onResurrected } from '../../util/AssetsUtil';
import _ from 'lodash';

export default class ResurrectQuery {
  updateProgress = _.noop;

  constructor(updateProgress) {
    this.updateProgress = updateProgress;
  }

  run(assets, paths) {
    const resurrectQuery = new FlexRemoteResurrectQuery();
    const message = new FlexRemoteResurrectArgs();
    message.setInfiles(paths);
    resurrectQuery.message = message;
    // this.updateProgress(0, t('PLEASE_WAIT'), 'RUNNING');
    resurrectQuery
      .run()
      .then(
        (resp) => {
          this.updateProgress(100, resp.getSuccessMessage(), 'DONE');
          if (!resp.isSuccess()) ErrorHandler.handleError(resp.getSuccessMessage());
          else {
            onResurrected(assets);
          }
        },
        (failedResp) => {
          const error = failedResp.errorDetails ? failedResp.errorDetails : t('DEFAULT_ERROR_MSG');
          ErrorHandler.handleError(error);
          this.updateProgress(100, error, null, false);
        }
      )
      .finally(() => {
        if (this.updateProgress) {
          this.updateProgress(100, '', null, false);
        }
      });
  }
}
